import connector from '@/utils/Connection'

export default {
  actions: {
    async getUser({dispatch, commit}, {userId}) {
      const responseUser = await connector.getUserInfo(userId);
      if (responseUser.error == 0 && responseUser.data != null) {
          this.state.userData = responseUser.data[0];
          this.state.userIsAdmin = responseUser.data[0].user_role === 2;
      }
      return responseUser;
    },
    async getUsers({dispatch, commit}) {
      const result = await connector.getUsersList();
      this.state.lastResponse = result;
      if (result.error == 0) {
        this.state.usersList = result.data.map(e => {
          return {...e, bindedPatients: null, patientsLoadError: 0,}
        });
        result.data = this.state.usersList;
      } else {
        this.state.usersList = [];
      }
      return result;
    }, 

    async updatePatient({dispatch, commit}, {userId, patientData}){
      const updateResult = await connector.updateLPatient(patientData);
      this.state.lastResponse = updateResult;
      if (updateResult.error == 0){ 
        const userIndex = this.state.usersList.findIndex((e, i, a) => e.id == userId);
        const patientIndex = this.state.usersList[userIndex].bindedPatients?.findIndex((e,i,a) => e.id == patientData.patientId);
        if (patientIndex != -1){
          this.state.usersList[userIndex].bindedPatients[patientIndex] = {
            id: updateResult.data.patient_id,
            d4wId: updateResult.data.patient_d4w_id,
            surname: updateResult.data.surname,
            firstname: updateResult.data.firstname,
            middlename: updateResult.data.middlename,
            dob: updateResult.data.dob,
            sex: updateResult.data.patient_sex,
            phone_mobile: updateResult.data.mobile,
            phone_home: updateResult.data.phone_home,
            email: updateResult.data.email,
            link_id: updateResult.data.link_id,
            confirmed: updateResult.data.patient_confirmed, 
          };
        }
      }
      return updateResult;
    },
    async getBindedPatients({dispatch, commit}, {userId}) {
      const userIndex = this.state.usersList.findIndex((e, i, a) => e.id == userId);
      if (userIndex == -1) 
        return {
          error: -3,
          message: 'Пользователь с данным Id не загружен',
          data: [],
      };
      const result = await connector.getUserPatients(userId);
      this.state.lastResponse = result;
      if (result.error == 0) {
        this.state.usersList[userIndex].bindedPatients = result.data.map(e => {
          return {
            id: e.patient_id,
            d4wId: e.patient_d4w_id,
            surname: e.surname,
            firstname: e.firstname,
            middlename: e.middlename,
            dob: e.dob,
            sex: e.patient_sex,
            phone_mobile: e.mobile,
            phone_home: e.phone_home,
            email: e.email,
            link_id: e.link_id,
            confirmed: e.patient_confirmed,        
          };
        });
        this.state.usersList[userIndex].patientsLoadError = 0;
        result.data = this.state.usersList[userIndex];
      } else {
        this.state.usersList[userIndex].bindedPatients = null;
        this.state.usersList[userIndex].patientsLoadError = result.error;
      }
      return result;   
    },
  }
}